import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const ROUND = () => {
  return (
    <CardSection id="ROUND" title="ROUND">
      <Paragraph>지정한 소수 자릿수로 숫자를 반올림합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>ROUND(VALUE, PLACES)</Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 반올림하려는 실수입니다.
          </Li>
          <Li>
            <b>PLACES</b>는 반올림할 소수 자릿수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>ROUND(`Column`, 2)</Paragraph>
        <Img src="computeRound" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 실수이거나, 실수를 포함하는 열이거나, 실수를
          반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          <b>PLACES</b> 값은 양의 정수여야 합니다 (음수 또는 소수점이
          포함되어서는 안 됩니다). 지정한 것보다 소수점 이하 자릿수가 있는{" "}
          <b>VALUE</b>는 <b>ROUND</b> 함수의 영향을 받지 않습니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
